import { render, staticRenderFns } from "./bv-bind-phone-share.vue?vue&type=template&id=6b1aa5d7"
import script from "./bv-bind-phone-share.vue?vue&type=script&lang=js"
export * from "./bv-bind-phone-share.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../apps/gouwubao/node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports